import { render, staticRenderFns } from "./EditEmployeeNotification.vue?vue&type=template&id=24b3a1a5"
import script from "./EditEmployeeNotification.vue?vue&type=script&lang=ts"
export * from "./EditEmployeeNotification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports